export const EMPTY_TEXT = '';
export const INITIAL_COUNTER_VALUE = 1;
export const COUNTER_STEP = 1;
export const SECOND_SHIFT = 2;
export const THIRD_SHIFT = 3;
export const MINIMUM_CHANGE_DESCRIPTION_LENGTH = 3;
export const FIRST_DAY_OF_MONTH = 1;
export const FIRST_MONTH = 1;
export const LAST_MONTH = 12;
export const JANUARY_INDEX = 0;
export const NOVEMBER_INDEX = 10;
export const DECEMBER_INDEX = 11;
export const CALENDAR_MONTH_OFFSET = 1;
export const NO_PENDING_GROUP_REQUESTS = 0;
export const NEXT_COMPLETED_GROUP_REQUEST = 1;
export const FIRST_REPORT_INDEX = 0;
export const SALARY_CALCULATION_SIGNED_INDEX = 4;
export const NO_VACATION_EXTENSION_DAYS = 0;
export const VACATION_DAY_ADJUSTMENT = 1;
export const MINIMUM_EXPERIENCE_YEAR = 2022;
export const INITIAL_DATE_PART = 0;
export const DATE_YEAR_PART_INDEX = 0;
export const DATE_MONTH_PART_INDEX = 1;
export const DATE_DAY_PART_INDEX = 2;
export const FIRST_ITEM_INDEX = 0;

export const EMPTY_GROUP_ID = '';
export const STANDARD_REPORT_TAB = 'standard';
export const LEGACY_STANDARD_TAB_VALUE = 'standar';
export const FLEXIBLE_REPORT_TAB = 'flexible';
export const NO_REPORT_MARKER = 'norep';
export const SALARY_CALCULATION_NEGATIVE_MARKER = '-';
export const SALARY_CALCULATION_POSITIVE_PREFIX = '+ ';
export const REPORT_DATE_PREFIX = 'Report from ';
export const REPORT_DATE_SEPARATOR = ' to ';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_SEPARATOR = 'T';
export const TIME_FORMAT = 'kk:mm:ss';
export const START_OF_DAY_SUFFIX = 'T00:00:00';
export const END_OF_DAY_SUFFIX = 'T23:59:59';
export const DATE_PART_SEPARATOR = '-';
export const DISPLAY_DATE_SEPARATOR = '.';
export const VACATION_DAYS_SIGN = '-';

export const GROUP_REPORT_ROUTE = '/dashboard/report/group';
export const PERSONAL_REPORT_ROUTE = '/dashboard/report/';
export const PERSONAL_REPORT_ROOT_ROUTE = '/dashboard/report';
export const DASHBOARD_ROUTE = '/dashboard';

export const MODAL_RESULT_OK = 'ok';
export const MODAL_RESULT_CONTINUE = 'continue';

export const REPORT_DATE_FROM_STORAGE_KEY = 'ReportDateFrom';
export const REPORT_DATE_TO_STORAGE_KEY = 'ReportDateTo';
export const REPORT_DATE_STORAGE_KEY = 'ReportDate';
export const REPORTS_STORAGE_KEY = 'Reports';
export const REPORT_TARGET_STORAGE_KEY = 'Drts';
export const GROUP_NAME_STORAGE_KEY = 'groupName';
export const DEPARTMENT_STORAGE_KEY = 'Dep';
export const VECTOR_STORAGE_KEY = 'dataList';
export const GROUP_REPORT_STORAGE_MARKER = 'group';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker.constants.ts